import type { SVGProps } from 'react';
const SvgWallet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <g clipPath="url(#Wallet_svg__a)">
      <path
        d="M14.204 12.136v.955A1.91 1.91 0 0 1 12.295 15H2.75a1.91 1.91 0 0 1-1.909-1.91V6.41a1.91 1.91 0 0 1 1.91-1.91m11.453 7.637a.955.955 0 0 0 .955-.954V8.317a.955.955 0 0 0-.955-.955m0 4.773h-2.386a2.386 2.386 0 1 1 0-4.773h2.386M2.75 4.5h9.545m-9.545 0 6.782-3.391a.954.954 0 0 1 1.281.427L12.295 4.5m0 0a1.91 1.91 0 0 1 1.91 1.909v.954"
        strokeLinejoin="round"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </g>
    <defs>
      <clipPath id="Wallet_svg__a">
        <path d="M0 0h16v16H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWallet;
